import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const createNylas = asyncThunkWrapper({ 
  model: 'nylas', 
  action: 'createNylas', 
  func: async (nylas_code) => {
    const response = await axios.post('/nylas', { nylas_code });

    return response.status;
  } 
});
export const deleteNylas = asyncThunkWrapper({ 
  model: 'nylas', 
  action: 'deleteNylas', 
  func: async () => {
    const response = await axios.delete(`/nylas`);

    return response.status;
  } 
});


